import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { PersonRole } from "@ha/data/basic";
import { LogDto, PermitLogEntryType } from "../../../models/permit-logs-dto";
import { TranslocoService } from "@ngneat/transloco";

@Component({
    selector: "pmt-permit-logs-log-item",
    templateUrl: "permit-logs-log-item.component.html",
    styleUrls: ["permit-logs-log-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermitLogsLogitemComponent implements OnInit {
    @Input() public log: LogDto;

    public transLocoString : string;

    constructor(private translocoService: TranslocoService) {}

    private readonly permitLogTranslationMap: Record<PermitLogEntryType, string> = {
        [PermitLogEntryType.SignedPermitBeforeStart]: "signedPermitBeforeStart",
        [PermitLogEntryType.SignedPermitDuringOngoingPermit]: "signedPermitDuringOngoingPermit",
        [PermitLogEntryType.SignedPermitAsPostWatchPeriodAtPermitEnd]: "signedPermitAsPostWatchPeriodAtPermitEnd",
        [PermitLogEntryType.SignedPermitAtPermitEnd]: "signedPermitAtPermitEnd",
        [PermitLogEntryType.AddedPhotoBeforeStart]: "addedPhotographBeforeStart",
        [PermitLogEntryType.AddedPhotoDuringOngoingPermit]: "addedPhotographDuringOngoingPermit",
        [PermitLogEntryType.AddedCommentDuringOngoingPermit]: "addedCommentDuringOngoingPermit",
        [PermitLogEntryType.AddedPhotoAtPermitEnd]: "addedPhotographAtPermitEnd",
        [PermitLogEntryType.RemovedPhoto]: "removedPhotograph",
        [PermitLogEntryType.RemovedComment]: "removedComment",
        [PermitLogEntryType.AddedCommentAtPermitEnd]: "addedCommentAtPermitEnd",
        [PermitLogEntryType.InquiredForTransferOfPermit]: "inquiredForTransferOfPermit",
        [PermitLogEntryType.ApprovedTransferOfPermit]: "approvedTransferOfPermit",
        [PermitLogEntryType.CanceledTransferOfPermit]: "canceledTransferOfPermit",
        [PermitLogEntryType.ClosedPermit]: "closedPermit",
        [PermitLogEntryType.StartedPermit]: "startedPermit",
        [PermitLogEntryType.ExportedPermit]: "exportedPermit",
        [PermitLogEntryType.MailedPermit]: "mailedPermit",
        [PermitLogEntryType.ExtendedPermit]: "extendedPermit",
        [PermitLogEntryType.AddedHotWorkerFireWatchOrFireWatchPostWatch]: "addedHotWorkerFireWatchOrFireWatchPostWatch",
        [PermitLogEntryType.NotificationsToStartPermitWasSent]: "notificationsToStartPermitWasSent",
        [PermitLogEntryType.NotificationsThatPermitsEndInOneHourWasSent]: "notificationsThatPermitsEndInOneHourWasSent",
        [PermitLogEntryType.NotificationsThatPermitsEndedWasSent]: "notificationsThatPermitsEndedWasSent",
        [PermitLogEntryType.NotificationsReminderToWriteOffPermitSent]: "notificationsReminderToWriteOffPermitSent",
        [PermitLogEntryType.SentNotificationForTransferOfPermit]: "sentNotificationForTransferOfPermit"
    };

    ngOnInit(): void {
        this.transLocoString = this.permitLogTranslationMap[this.log.permitLogEntryType];
    }

    public translateRoleEnum(role: PersonRole): string {
        return this.translocoService.translate("permit.permitRole." + + `${role}`);
    }

    getFullNameWithExtern(log: LogDto): string {
        const externText = log.isExtern ? this.translocoService.translate("permit.details.logs.extern") : '';
        return `${log.currentPersonFullName}${externText ? ' ' + externText : ''}`;;
    }
}
